import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { PlayerProvider } from "@/context/PlayerContext";
import Noise from "@/components/Noise";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PlayerBar from "@/components/PlayerBar";
import Home from "@/pages/Home";
import Music from "@/pages/Music";
import Merch from "@/pages/Merch";
import About from "@/pages/About";
import Subscribe from "@/pages/Subscribe";
import Tour from "@/pages/Tour";
import Admin from "@/pages/Admin";
import Label from "@/pages/Label";
import Artist from "@/pages/Artist";
import Contact from "@/pages/Contact";
import Photos from "@/pages/Photos";
import InstallApp from "@/components/InstallApp";
import IntroGate from "@/components/IntroGate";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15 });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <PlayerProvider>
      <BrowserRouter>
        <Noise />
        <IntroGate />
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/music" element={<Music />} />
          <Route path="/tour" element={<Tour />} />
          <Route path="/merch" element={<Merch />} />
          <Route path="/about" element={<About />} />
          <Route path="/label" element={<Label />} />
          <Route path="/artist/:id" element={<Artist />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Photos />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
        <Footer />
        <PlayerBar />
        <InstallApp />
        <Toaster position="bottom-right" theme="dark" />
      </BrowserRouter>
    </PlayerProvider>
  );
}

export default App;
